import { Spinner } from '#assets/Spinner.tsx';
import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { ModalBody, ModalFooter } from '#components/patterns/modal/index.ts';

type Props = {
  /** If not `undefined`, show the download modal with `downloadURL` as the download link */
  downloadURL?: string;
  /** The filename to recommend for the system to save as */
  fileName: string;
};

/**
 * {@link DownloadLogs} will render a loading spinner while waiting for a file to provide.
 * Once provided with a `downloadURL`, it will render that as a download modal.
 */
export function DownloadLogs({ downloadURL, fileName }: Props) {
  const isReady = Boolean(downloadURL);

  return (
    <>
      <ModalBody className="flex flex-col align-center">
        <Spinner className="mb-40" size={80} state={isReady ? 'success' : 'spinning'} />
        {isReady ?
          <>
            <p className="h3">Download your logs!</p>
            <p className="p text-center">
              Your logs have finished processing, and the generated CSV file is ready to save.
            </p>
          </>
        : <>
            <p className="h3">Preparing logs...</p>
            <p className="p text-center">We’re packaging up your audit logs. It should only take a moment.</p>
          </>
        }
      </ModalBody>
      <ModalFooter>
        {isReady ?
          <LinkButton fullWidth href={downloadURL} download={fileName}>
            Download
          </LinkButton>
        : null}
      </ModalFooter>
    </>
  );
}
